import {ApiService} from './../apiService.js'
const ApiService_ = new ApiService;
const client = ApiService_.client;
const apiurl = ApiService_.API_URL;

export class UserService{

    static getUser(user){
        const url = apiurl+`api/student`;
        return client.post(url, user, {
            headers:{
                'Content-Type': 'application/json'
            }
        });
    }

    static register(user){
        const url = apiurl+`dha/tuition/payment`;
        return client.post(url, user, {
            'headers': {
                'Content-Type': 'application/json'
            }
        });
    }

    static balance(user) {
        const url = apiurl+`student/balance`;
        return client.post(url, user, {
            'headers': {
                'Content-Type': 'application/json'
            }
        });
    }

    static submitSheet(){
        const url = `https://script.google.com/macros/s/AKfycby3gG3U26NJJXJoMp2Ew5cPjlHPIMtk70l-i6p5fzc7X5zqLgUD9PVaPQKoxN7D5mk/exec?name=gitika&email_address=gitikakhanna392@gma.com&phoneno=971195075`;
        return client.get(url, {
            headers: {
                "Access-Control-Allow-Origin": "*",
            }
        });
    }
}